import axios from "axios";
import { Partner_Service_URL } from "../Url";




export const getThresholdChangeActions = {
  GET_THRESHOLD_CHANGE_SUCCESS: "GET_THRESHOLD_CHANGE_SUCCESS",
  GET_THRESHOLD_CHANGE_ERROR: "GET_THRESHOLD_CHANGE_ERROR",
};

export function getThresholdChangeDetails(props) {
  const { access_token, values, partnerFirmId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/getleadThresholdAllowBeforeRegistartion?partnerFirmId=${partnerFirmId}`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getThresholdChangeSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getThresholdChangeError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getThresholdChangeError(err));

          return err.response;
        }
      });
}

export function getThresholdChangeError(error) {
  return {
    type: getThresholdChangeActions.GET_THRESHOLD_CHANGE_ERROR,
    payload: error,
  };
}

export function getThresholdChangeSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getThresholdChangeActions.GET_THRESHOLD_CHANGE_SUCCESS,
      payload: props,
    });
  };
}
